import { defineMessages } from 'react-intl';

export const scope = 'app.base.component.dropdown';

export default defineMessages({
  create_new: {
    id: `${scope}.create_new`,
    defaultMessage: 'Create New',
  },
  no_results_found: {
    id: `${scope}.no_results_found`,
    defaultMessage: 'No results found',
  },
});
